var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("pulse-loader", {
        staticClass: "text-center",
        attrs: { loading: _vm.loading, color: _vm.$constants.LOADING_COLOR },
      }),
      _vm._v(" "),
      !_vm.loading
        ? [
            _vm.task
              ? _c(
                  "div",
                  [
                    _c("p", { staticClass: "text-muted" }, [
                      _vm._v(
                        _vm._s(_vm.printDate(_vm.task.created_at)) +
                          "\n        "
                      ),
                      _vm.task.is_active
                        ? _c(
                            "button",
                            {
                              staticClass: "btn btn-info btn-xs",
                              on: { click: _vm.getRequest },
                            },
                            [
                              _c("i", {
                                staticClass: "icon-fa icon-fa-refresh",
                              }),
                            ]
                          )
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.task.task_data, function (c) {
                      return _c("p", [
                        _vm._v(
                          _vm._s(c.number.substr(c.number.length - 4)) + ": "
                        ),
                        _c("strong", [_vm._v(_vm._s(c.amount))]),
                      ])
                    }),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v("Всего: "),
                      _c("strong", [_vm._v(_vm._s(_vm.totalAmount))]),
                    ]),
                  ],
                  2
                )
              : _vm._e(),
            _vm._v(" "),
            !_vm.requestSent && !_vm.task
              ? _c("LoadingButton", {
                  attrs: {
                    title: "Собрать баланс карт (≈ 3 мин)",
                    loading: _vm.btnLoading,
                    color: _vm.$constants.PRIMARY_COLOR,
                    onClick: () => _vm.collectBalance(),
                    className: "btn btn-outline-info btn-xs",
                  },
                })
              : _vm._e(),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }